import { ProductsTFunction } from '@retail/products/i18n';

export const supplierItemsColumnHeaders = (
  t: ProductsTFunction
): Record<SupplierItemsExportColumn, string> => ({
  inAssortment: t('products.search.itemsInMyAssortment'),
  mgItemNumber: t('products.mgItem.number.label'),
  finfoNumber: t('products.mgItem.details.externalId.FINFO'),
  nobbNumber: t('products.mgItem.details.externalId.NOBB'),
  primaryText: t('products.mgItem.details.primaryText'),
  secondaryText: t('products.mgItem.details.secondaryText'),
  supplierNumber: t('products.mgItem.details.supplierId'),
  supplierName: t('products.supplier.name'),
  productGroupNumber: t('products.search.productGroup.label'),
  discontinuationDate: t('products.mgItem.details.discontinuationDate'),
  discontinuationStatus: t('products.mgItem.details.discontinuation'),
});

export type SupplierItemsExportColumn =
  | 'inAssortment'
  | 'mgItemNumber'
  | 'finfoNumber'
  | 'nobbNumber'
  | 'primaryText'
  | 'secondaryText'
  | 'supplierNumber'
  | 'supplierName'
  | 'productGroupNumber'
  | 'discontinuationStatus'
  | 'discontinuationDate';
